<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 32 32"
    class="fill-current"
    xmlns:v="https://vecta.io/nano"
  >
    <path
      d="M19.2 11V1h1v8c2.1-1.6 4.5-2.7 7.1-3.5l.3.9a20.68 20.68 0 0 0-7.5 3.9l-.9.7zm1 20.1h-1V27c0-6.7 4.9-12.6 11.9-14.4l.2.9c-6.6 1.7-11.2 7.3-11.2 13.5v4.1z"
    />
    <path
      d="M20.2 26.9h-1V9.7l.2-.1c2.4-1.9 5.2-3.3 8.3-4.2l.3.9c-2.9.8-5.5 2.1-7.7 3.8v11.7c1.8-4.5 5.8-8 10.9-9.4l.2.9c-6.6 1.8-11.2 7.4-11.2 13.6z"
    />
    <path
      d="M12.8 24.8h-1V.9h1v17.9a19.99 19.99 0 0 1 6.4-9.1V.9h1v9.3l-.2.1c-4.6 3.7-7.2 9-7.2 14.5z"
    />
    <path d="M11.8.9h1V31h-1z" />
    <path
      d="M20.2 31.1h-1V11c-4.1 3.6-6.4 8.6-6.4 13.8v6.3h-1v-6.3c0-5.8 2.7-11.4 7.5-15.2l.8-.6v22.1z"
    />
    <path
      d="M16,32C7.2,32,0,24.8,0,16C0,7.2,7.2,0,16,0c8.8,0,16,7.2,16,16C32,24.8,24.8,32,16,32z M16,1    C7.7,1,1,7.7,1,16s6.7,15,15,15s15-6.7,15-15S24.3,1,16,1z"
    />
  </svg>
</template>
